module.exports = __webpack_public_path__ + "images/directory/carousel/gusto.83a7a199d854d0561f6e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/carousel/gusto.png
// module id = 0j2L
// module chunks = 2